import React from 'react'
import {BsPatchCheckFill} from "react-icons/bs"
import "./Experience.css"

const Experience = () => {
  return (
    <section id="experience">
      <h5>What skills i have</h5>
      <h2>My experience</h2>

      <div className="container experience__container">
        <div className="experience__frontend">
          <h3>Frontend Development</h3>
          <div className="experience__content">
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon"/>
              <div>
              <h4>HTML</h4>
              </div>
              
            </article>
            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon"/>
              <div>
              <h4>CSS</h4>
              </div>
              
            </article>

            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon"/>
              <div>
              <h4>JAVASCRIPT</h4>
              </div>
              
            </article>

            <article className="experience__details">
              <BsPatchCheckFill className="experience__details-icon"/>
              <div>
              <h4>REACT</h4>
              </div>
              
            </article>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Experience